import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { BaseListComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-list.component";
import { OrderService } from "../../../order.service";
import { FormContainerModel } from "projects/sepidz-web-framework-shell/src/lib/tabular/form-container-model";
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { isNullOrEmptyString } from "@progress/kendo-angular-grid/dist/es2015/utils";
import { InvoiceService } from "../../invoice/invoice.service";

@Component({
  selector: "order-pagerfastaccess",
  templateUrl: "./pagerfastaccess.component.html",
  styleUrls: ["./pagerfastaccess.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PagerFastAccessComponent extends BaseListComponent {
  constructor(public invoiceservice: InvoiceService, public order: OrderService, __id: FormContainerModel, public cd: ChangeDetectorRef) {
    super();
    this.currentTabId = __id.metadata.id;
    this.order.cd_FastAccessPager = cd;
  }

  ngOnInit() {
    let group: any = {};
    group["inputPager"] = new UntypedFormControl(null, Validators.required);
    this.group = new UntypedFormGroup(group);
    this.group.controls["inputPager"].setValue("");
  }

  SetInputPager(numberValue: number) {
    this.group.controls["inputPager"].setValue(`${this.group.controls["inputPager"].value}` + numberValue.toString());
  }

  BackSpaceInputPager() {
    let inputPagerValue: string = this.group.controls["inputPager"].value;
    let newInputPagerValue = inputPagerValue.substr(0, inputPagerValue.length - 1);
    this.group.controls["inputPager"].setValue(newInputPagerValue);
  }

  ClearInputPager() {
    this.group.controls["inputPager"].setValue("");
  }

  SetInvoicePager() {
    let inputPagerValue: string = this.group.controls["inputPager"].value;

    if (inputPagerValue && !isNullOrEmptyString(inputPagerValue)) {
      this.order.invoice.Description =
        this.order.invoice["Description"].valueOf() +
        this.translate("ClientApp.FrontOffice.Order.OrderPage.Fastaccess.PagerFastaccess.PagerNumber") +
        inputPagerValue;
      this.order.formGroup.controls["Description"].setValue(this.order.invoice.Description);

      this.order.invoiceChanged = true;
    }
    this.order._opened = false;
  }

  SetInvoicePagerDestCustomerKitchen() {
    let inputPagerValue: string = this.group.controls["inputPager"].value;

    if (inputPagerValue && !isNullOrEmptyString(inputPagerValue)) {
      this.order.invoice.DescCustomer =
        this.order.invoice["DescCustomer"].valueOf() +
        this.translate("ClientApp.FrontOffice.Order.OrderPage.Fastaccess.PagerFastaccess.PagerNumber") +
        inputPagerValue;
      this.order.formGroup.controls["DescCustomer"].setValue(this.order.invoice.DescCustomer);

      this.order.invoice.DescKitchen =
        this.order.invoice["DescKitchen"].valueOf() +
        this.translate("ClientApp.FrontOffice.Order.OrderPage.Fastaccess.PagerFastaccess.PagerNumber") +
        inputPagerValue;
      this.order.formGroup.controls["DescKitchen"].setValue(this.order.invoice.DescKitchen);

      this.order.invoiceChanged = true;
    }
    this.order._opened = false;
  }
}
